import { useEntities } from './useEntities'
import { ShoppingCartV2 } from '@obeta/models/lib/models/ShoppingCart/ShoppingCart'

export const useShoppingCartById = (id: string) => {
  const shoppingCarts = useEntities<ShoppingCartV2>('cartsv2')

  return shoppingCarts.find((cart) => cart.id === id) || null
}
